import { defineComponent as _defineComponent } from 'vue'
import BlockLedCalculatorFormInput from '@/ui/shared/blocks/LedCalculator/BlockLedCalculatorFormInput.vue';
import { calculatorFormViewModel } from '@/ui/shared/blocks/LedCalculator/LedCalculatorTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLedCalculatorForm',
  props: {
    calculator: null
  },
  setup(__props: any) {



return { __sfc: true,BlockLedCalculatorFormInput }
}

})